import { render, staticRenderFns } from "./ChangeIsPermanent.vue?vue&type=template&id=3002b504&"
import script from "./ChangeIsPermanent.vue?vue&type=script&lang=js&"
export * from "./ChangeIsPermanent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports